import React from 'react'
import Navbar from "../navbar/Navbar";
import image from "../../images/logo.png"
import "./Header.scss"

const Header = ({buttons}) => {
  return (
    <div className='header'>
      <img src={image} alt="" width="80px"/>
       <Navbar buttons={buttons}/>
    </div>
  )
}

export default Header
